import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import VendorHeader from './vendorHeader';
import '../SuperAdmin/addcategory.css';
import './sidebar2.css';
import './UserProfile.css';
import './allproduct.css';
import infogif from '../icons/gifinfo.gif';
import noimg from '../icons/noimg.png';
import menu from '../icons/menu.png'; 
import Navbar from '../components/navbar';
import loginlearn1 from '../icons/loginlearn1.png';
import profilelearn from '../icons/profilelearn.png';
import loginlearn from '../icons/productlearn.png';
import orderlearn from '../icons/orderlearn.png';
import securelearn from '../icons/securelearn.png';

const Allproducts = () => {
    const [sidebarmenuOpen, setSidebarmenuOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  
  const [vendorData, setVendorData] = useState({ selectType: '' }); // Define vendorData state
  const [productCount, setproductCount] = useState(0); 
  const toggleVendorsidebar = () => {
    setSidebarmenuOpen(!sidebarmenuOpen);
  };
  
  // Close Sidebar
  const closeSidebar = () => {
    setSidebarmenuOpen(false);
  };
  useEffect(() => {
    const vendorId = localStorage.getItem('vendorId');
    if (!vendorId) {
      alert('Vendor ID not found in local storage');
      return;
    }
    
    // You need to define vendortoken or remove this request if not used
    const vendortoken =  localStorage.getItem('vendortoken'); // Define or get vendortoken if needed

    axios.post(`${process.env.REACT_APP_API_URL}/vendorData`, { vendortoken })
      .then(response => {
        if (response.data.status === 'ok') {
          setVendorData(response.data.data);
        } else {
          setError(response.data.message);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setError(error.message);
      });

    fetch(`${process.env.REACT_APP_API_URL}/getVendorProduct`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ vendorId })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'ok') {
        setProducts(data.data);
      } else {
        console.error('Error:', data.message);
        setMessage('Error fetching products: ' + data.message);
      }
    })
    .catch(error => {
      console.error('Fetch error:', error);
      setMessage('Error fetching products');
    });

  axios.post(`${process.env.REACT_APP_API_URL}/getVendorProductcount`, { vendorId })
  .then(response => {
    if (response.data.status === 'ok') {
      setproductCount(response.data.data.productCount); // Set the count
    } else {
      setMessage('Error fetching category count: ' + response.data.message);
    }
  })
  .catch(error => {
    console.error('Error fetching category count:', error);
    setMessage('Error fetching category count');
  });
}, []);

  const handleUpdate = (productId) => {
    window.location.href = `/UpdateProperty/${productId}`;
  };
  const handleLogout = () => {
    localStorage.removeItem('vendorId'); // Remove vendorId
    window.location.href = '/vendor/login'; // Redirect to login page
  };
  const handleSubMenuToggle = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };

  const handleDelete = (productId) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      fetch(`${process.env.REACT_APP_API_URL}/deletePropertyVendor`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ productId })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'ok') {
          // Remove the deleted product from the state
          setProducts(products.filter(product => product._id !== productId));
          setMessage('Product deleted successfully');
        } else {
          console.error('Error:', data.message);
          setMessage('Error deleting product: ' + data.message);
        }
      })
      .catch(error => {
        console.error('Delete error:', error);
        setMessage('Error deleting product');
      });
    }
  };

  return (
    <div className="update-profile-vendor">
     <Navbar />
            <div className="vendor-sidebarmobile-menu mx-2 mt-2">
             <div style={{ position: "relative" }}>
               <img 
                 src={menu} 
                 width={30} 
                 alt="Menu" 
                 className="usermenu-bar-vendor" 
                 onClick={toggleVendorsidebar}
               />
             </div>
           </div>
      <div className="content row mt-4">
       <div className='col-sm-3 desktop-vendor-sidebar'>
               <ul className='VendorList'>
                 <li className='list'> <Link to="/Vendor/Dashboard"><i className="fas fa-home sidebaricon"></i> Dashboard</Link></li>
               </ul>
               <ul className="nano-content VendorList">
                 <li className={`sub-menu list ${activeSubMenu === 5 ? 'active' : ''}`}>
                   <a href="#!" onClick={() => handleSubMenuToggle(5)}>
                     <i className="fas fa-user-alt sidebaricon"></i><span>Profile</span><i className="arrow fa fa-angle-right pull-right"></i>
                   </a>
                   <ul style={{ display: activeSubMenu === 5 ? 'block' : 'none' }} className='vendorsidebarmenu'>
                     <li className='list_sidebar'><Link to="/Vendor/UserProfile" className='listsidebar'>User Profile</Link></li>
                     <li className='list_sidebar'><Link to="/Vendor/BusinessProfile" className='listsidebar'>Business Profile</Link></li>
                    {/* <li className='list_sidebar'><Link to="/Vendor/BankDetails" className='listsidebar'>Bank Details</Link></li>*/}
                   </ul>
                 </li>
                 <li className={`sub-menu list ${activeSubMenu === 0 ? 'active' : ''}`}>
                   <a href="#!" onClick={() => handleSubMenuToggle(0)}>
                     <i className="fab fa-product-hunt sidebaricon"></i><span>Product</span><i className="arrow fa fa-angle-right pull-right"></i>
                   </a>
                   <ul style={{ display: activeSubMenu === 0 ? 'block' : 'none' }} className='vendorsidebarmenu'>
                   <li className='list_sidebar'><Link to="/Vendor/AllProduct" className='listsidebar'>All Product</Link></li>
                   <li className='list_sidebar'><Link to="/Vendor/AddProductVendor" className='listsidebar'>Add Product</Link></li>
                   </ul>
                 </li>
               
              
                 <ul className='VendorList' onClick={handleLogout}>
                 <li className='list'><i className="fas fa-sign-out-alt sidebaricon"></i>Logout</li>
               </ul>
              
               </ul>
           
             </div>
           
     
           {/* Sidebar */}
           <div className={`mobiles-vendor-sidebar ${sidebarmenuOpen ? "active" : ""}`}>
             <div className="overlay">
               <div className="text-left mobileclose-btn">
                 <button className="mt-2 closebtn" onClick={toggleVendorsidebar}>
                   <i className="fas fa-arrow-left"></i>
                 </button>
               </div>
               <ul className="VendorList">
                 <li className="list">
                   <Link to="/Vendor/Dashboard">
                     <i className="fas fa-home sidebaricon"></i> Dashboard
                   </Link>
                 </li>
               </ul>
               <ul className="nano-content VendorList">
                 <li className={`sub-menu list ${activeSubMenu === 5 ? 'active' : ''}`}>
                   <a href="#!" onClick={() => handleSubMenuToggle(5)}>
                     <i className="fas fa-user-alt sidebaricon"></i><span>Profile</span><i className="arrow fa fa-angle-right pull-right"></i>
                   </a>
                   <ul style={{ display: activeSubMenu === 5 ? 'block' : 'none' }} className='vendorsidebarmenu'>
                     <li className='list_sidebar'><Link to="/Vendor/UserProfile" className='listsidebar'>User Profile</Link></li>
                     <li className='list_sidebar'><Link to="/Vendor/BusinessProfile" className='listsidebar'>Business Profile</Link></li>
                    {/* <li className='list_sidebar'><Link to="/Vendor/BankDetails" className='listsidebar'>Bank Details</Link></li>*/}
                   </ul>
                 </li>
                 <li className={`sub-menu list ${activeSubMenu === 0 ? 'active' : ''}`}>
                   <a href="#!" onClick={() => handleSubMenuToggle(0)}>
                     <i className="fab fa-product-hunt sidebaricon"></i><span>Product</span><i className="arrow fa fa-angle-right pull-right"></i>
                   </a>
                   <ul style={{ display: activeSubMenu === 0 ? 'block' : 'none' }} className='vendorsidebarmenu'>
                   <li className='list_sidebar'><Link to="/Vendor/AllProduct" className='listsidebar'>All Product</Link></li>
                   <li className='list_sidebar'><Link to="/Vendor/AddProductVendor" className='listsidebar'>Add Product</Link></li>
                   </ul>
                 </li>
               
              
                 <ul className='VendorList' onClick={handleLogout}>
                 <li className='list'><i className="fas fa-sign-out-alt sidebaricon"></i>Logout</li>
               </ul>
              
               </ul>
             </div>
           </div>
        <div className='col-sm-8'>
          <div className='product-container'>
            <h2 className='title-vendorInfo'>All Products</h2>
            <div className='total_addbtn'>
            <span>{productCount} Product</span> 
            <Link to="/Vendor/AddProductVendor" className='btn addbtn'>Add New Product</Link>
            </div>
            {message && <p>{message}</p>}
            {products.length > 0 ? (
  <div>
    {products.map((product) => (
      <div className="productDetailsvendor d-flex" key={product._id}>
        <div className="">
          {product.image ? (
            <img
            src={`${process.env.REACT_APP_API_URL}/${product.image.replace('\\', '/')}`}
            alt={product.name}
            style={{ width: '84px', height: '84px' }}
          />
          
          ) : (
            <img
            src={noimg}
            alt={product.name}
            style={{ width: '84px', height: '84px' }}
          />
            
           
          )}
        </div>
        <div className="product-details">
          <h5 className='product-name-vendor'>{product.name}</h5>
        
          <span className='m-2'>₹{product.price}</span>
          <div>
          <span className='pending-items'>
          {product.active ? 'Active' : 'Inactive'}
            </span>
            <span className='category-items m-2'> 
  {product.category?.name || 'Category Not Available'}
</span>

{product.approved ? (
    <span className='approved-items'>Approved</span>
) : (
    <span className='reject-items'>Reject</span>
)}

    


</div>

       
       
        </div>
        <div className="edit-deleteflex">
          <button
            onClick={() => handleUpdate(product._id)}
            className="edit-delete"
          >
            <i className="fas fa-edit"></i>
          </button>
          <button
            onClick={() => handleDelete(product._id)}
            className="edit-delete"
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>
    ))}
  </div>
) : (
  <p>No Categories Found</p>
)}

 
          </div>
        </div>
      {/*  <div className='col-sm-3'>
          <div className='learning-container'>
          <h2 className='title-vendorInfo'>Learning Center</h2>
          <div class=" d-flex learning-cards">
            <div class="card-body mr-4">
             
                <span class="about">Login</span>
              <div class="card-content">
                <span class=" learncontent">
                Simply enter your username and password to log in and get started!</span></div>
               </div>
                    <div class="card-logo d-flex align-items-center"><div class="imgBox">
                      <img src={loginlearn1} alt="logo" loading="eager" width="80" height="auto" class="logo"/>
                      </div></div>
          
         
        </div>
        <div class=" d-flex learning-cards">
            <div class="card-body mr-4">
             
                <span class="about">Create Your Vendor Profile </span>
              <div class="card-content">
                <span class=" learncontent">
                Set up your vendor profile by providing your details to start selling on our platform.</span></div>
               </div>
                    <div class="card-logo d-flex align-items-center"><div class="imgBox">
                      <img src={profilelearn} alt="logo" loading="eager" width="80" height="auto" class="logo"/>
                      </div></div>
          
         
        </div>
        <div class=" d-flex learning-cards">
            <div class="card-body mr-4">
             
                <span class="about">Add Your Products</span>
              <div class="card-content">
                <span class=" learncontent">
                Easily list your products with descriptions, images, and prices to attract customers.</span></div>
               </div>
                    <div class="card-logo d-flex align-items-center"><div class="imgBox">
                      <img src={loginlearn} alt="logo" loading="eager" width="80" height="auto" class="logo"/>
                      </div></div>
          
         
        </div>
        <div class=" d-flex learning-cards">
            <div class="card-body mr-4">
             
                <span class="about">Manage Orders</span>
              <div class="card-content">
                <span class=" learncontent">
                Track and manage your orders with real-time updates for a smooth selling experience.</span></div>
               </div>
                    <div class="card-logo d-flex align-items-center"><div class="imgBox">
                      <img src={orderlearn} alt="logo" loading="eager" width="80" height="auto" class="logo"/>
                      </div></div>
          
         
        </div>
        <div class=" d-flex learning-cards">
            <div class="card-body mr-4">
             
                <span class="about">Get Paid Securely</span>
              <div class="card-content">
                <span class=" learncontent">
                Receive payments directly to your account with our secure and reliable payment system.</span></div>
               </div>
                    <div class="card-logo d-flex align-items-center"><div class="imgBox">
                      <img src={securelearn} alt="logo" loading="eager" width="80" height="auto" class="logo"/>
                      </div></div>
          
         
        </div>
      </div>
    </div>*/}
    </div>
    </div>
    
  );
};
export default Allproducts;
